import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors }) => ({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: spacing(3),
  },
  content: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    gap: spacing(2),
  },
  control: {
    flexShrink: 0,
    justifyContent: "center",
  },
  description: {
    color: colors.foregroundDefaultMuted,
  },
  disabled: {
    opacity: 0.4,
  },
}));

export default stylesheet;
